<template>
	<div
		class="detail_page"
		v-if="curProject"
	>

		<div class="main">
			<h2 v-html="curProject.title_long"></h2>
			<div class="swiper">
				<div
					class="swiper-container"
					ref="imglist"
				>
					<div
						class="swiper-wrapper"
						ref="fancybox"
					>
						<!-- Slides -->
						<div
							v-for="item in imgs"
							:key="item.key"
							class="swiper-slide"
							:href="item.src"
						>
							<img
								:src="item.src"
								alt=""
							>
						</div>

					</div>

				</div>
				<span
					class="scale_icon"
					ref="scale_icon"
				></span>
				<div class="swiper-pagination"></div>
			</div>
			<div
				class="content article_wrap"
				v-html="curProject.desc"
			>

			</div>
		</div>
	</div>
</template>
<script>
import Swiper, { Pagination, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Pagination, Autoplay]);
// import Swiper styles
import projectApi from "../api/projects";
import "swiper/swiper-bundle.css";
export default {
	data() {
		return {
			curProject: null,
			id: 0,
		};
	},
	created() {
		var id = this.$route.params.id.split("-");
		this.curProject = projectApi[id[0] - 1]["projects"][id[1] - 1];
		this.id = id;
	},
	mounted() {
		if ($(".swiper-container .swiper-slide").length > 1) {
			this.myswiper = new Swiper(".swiper-container", {
				loop: true,
				// allowTouchMove: false,
				autoplay: {
					delay: 3000,
				},
				pagination: {
					el: ".swiper-pagination",
				},
			});
			$(window).resize(() => {
				this.myswiper.updateSize();
			});
		}

		$.fancybox.destroy();
		$(this.$refs.fancybox)
			.children()
			.fancybox({
				hash: false,
				buttons: ["close"],
				arrows: false,
				infobar: false,
			});
		$(this.$refs.scale_icon).click((e) => {
			var curEl = this.myswiper
				? this.myswiper.slides[this.myswiper.activeIndex]
				: $(".swiper-container").find(".swiper-slide");
			//if(this.myswiper)
			// var curEl = this.myswiper.slides[this.myswiper.activeIndex];

			curEl.click();
		});
	},
	computed: {
		imgs() {
			var imgs = [];
			for (var i = 0; i < this.curProject.img_count; i++) {
				imgs.push({
					src:
						"images/area/" +
						this.id[0] +
						"/project" +
						this.id[1] +
						"/img" +
						(i + 1) +
						".jpg",
					id: this.id + "" + i,
				});
			}
			return imgs;
		},
	},
};
</script>
<style lang="less" scoped>
.detail_page {
	overflow: hidden;
	h2 {
		text-align: center;
		font-size: 0.35rem;
		line-height: 1.2;
		position: absolute;
		width: 100%;
		bottom: 94%;
		left: 0;
		text-shadow: 0px 0px 5px #056ee1;
	}
	.swiper-pagination {
		bottom: -0.2rem;
		width: 100%;
		text-align: center;
		left: -0.03rem;
		& /deep/ .swiper-pagination-bullet {
			width: 0.08rem;
			height: 0.08rem;
			opacity: 1;
			background-color: #31ccff;
			margin: 0 0.1rem;
		}
		& /deep/ .swiper-pagination-bullet-active {
			background-color: #d1feff;
		}
	}
	.main {
		position: relative;
		width: 13.56rem;
		height: 5.73rem;
		background: url("../assets/detail_bg.png") no-repeat center/100% 100%;
		max-width: 95%;
		margin: 0 auto;
		margin-top: 1rem;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		padding: 0 0.3rem;
		.swiper {
			position: relative;
			flex-shrink: 0;
			flex-grow: 0;
			width: 3.71rem;
			height: 3.62rem;
			background: url("../assets/swiper_bg.png") no-repeat center/100%
				100%;
			box-sizing: border-box;
			padding: 0.18rem;
			.scale_icon {
				display: inline-block;
				width: 1rem;
				height: 1rem;
				background: url("../assets/scale_icon.png") no-repeat
					center/contain;
				position: absolute;
				left: 50%;
				top: 50%;
				margin-left: -0.5rem;
				margin-top: -0.3rem;
				z-index: 100;
				animation: huxi2 0.6s ease-in-out 0s infinite alternate-reverse
					both;
			}
			.swiper-container {
				width: 100%;
				height: 100%;
				.swiper-slide {
					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
			}
		}
		.content {
			width: 100%;
			text-align: left;
			margin-left: 0.7rem;
			height: 4.6rem;
			overflow: auto;
			margin-top: 0.4rem;
			-webkit-overflow-scrolling: touch;
			line-height: 1.6;
			padding-left: 0.2rem;
			// & /deep/ h4 {
			// 	position: relative;
			// 	margin: 0.2rem 0 0;
			// 	font-size: 0.16rem;
			// 	&::before {
			// 		content: "";
			// 		display: inline-block;
			// 		width: 0.05rem;
			// 		height: 0.05rem;
			// 		background: #00e7ff;
			// 		border-radius: 0.025rem;
			// 		position: absolute;
			// 		left: -0.2rem;
			// 		top: 50%;
			// 		margin-top: -0.025rem;
			// 	}
			// }
			// & /deep/ p {
			// 	color: #00c0ff;
			// 	font-size: 0.14rem;
			// }
		}
	}
}
</style>